import { render, staticRenderFns } from "./NsFooterNav.vue?vue&type=template&id=91b010b2&scoped=true&"
import script from "./NsFooterNav.vue?vue&type=script&lang=js&"
export * from "./NsFooterNav.vue?vue&type=script&lang=js&"
import style0 from "./NsFooterNav.vue?vue&type=style&index=0&id=91b010b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b010b2",
  null
  
)

export default component.exports